/**
 * Created by ZhangJunPeng on 2017/5/22.
 */

import React from 'react';
import { ContextMenuTrigger } from 'react-contextmenu';
import WeekView from './WeekView';
import DayView from './DayView';
import { CALENDAR_TIME_TYPE } from '../../utils/constants';

export default class SearchView extends React.Component {
  render() {
    const { createMeetingHandle, handleByClickDay, timeType } = this.props;
    return (
      <ContextMenuTrigger id="search_index">
        {timeType === CALENDAR_TIME_TYPE.week && (
          <WeekView
            {...this.props}
            createMeetingHandle={createMeetingHandle}
            handleByClickDay={handleByClickDay}
            viewType="week"
            timeType={2}
          />
        )}
        {timeType === CALENDAR_TIME_TYPE.day && (
          <DayView
            {...this.props}
            createMeetingHandle={createMeetingHandle}
            handleByClickDay={handleByClickDay}
            timeType={1}
          />
        )}
      </ContextMenuTrigger>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/meeting/SearchView.js